module.exports = __webpack_public_path__ + "static/students-69ab77be9dc643c13fce1dec03026817.jpg";